import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";

// Dashboard pages
import Dashboard from "@/pages/Dashboard/Dashboard.vue";

// Pages
import User from "@/pages/Dashboard/Pages/UserProfile.vue";
import Login from "@/pages/Dashboard/Pages/Login.vue";
import Forgot from "@/pages/Dashboard/Pages/Forgot.vue";
import MyOrders from "@/pages/Dashboard/Orders/MyOrders.vue";

import UpComingShipments from "@/pages/Dashboard/Shipping/upcomingshipments.vue";



// Components pages
import Buttons from "@/pages/Dashboard/Components/Buttons.vue";
import Panels from "@/pages/Dashboard/Components/Panels.vue";

let userMenu = {
    path: "/user",
    component: DashboardLayout,
    redirect: "/user/profile",
    name: "My profile",
    meta: { requiresAuth: true, roles: ["customer"] },
    children: [
        {
            path: "profile",
            name: "My profile",
            components: User,
            meta: { requiresAuth: true }
        }
    ]
};



let ordersMenu = {
    path: "/orders",
    redirect: "/orders/myorders",
    component: DashboardLayout,
    name: "MyOrders",
    meta: { requiresAuth: true},
    children: [
        {
            path: "myorders",
            name: "pages.dashboard.myorders",
            components: { default: MyOrders },
            meta: { requiresAuth: true}
        },
    ]
};

let shippingMenu =
{
    path: "/:accountId/shipping",
    redirect: "/shipping/upcoming",
    component: DashboardLayout,
    name: "Orders",
    meta: { requiresAuth: false, roles: ["employee"] },
    children: [
        {
            path: "upcoming",
            name: "pages.shipments.pagetitle",
            components: { default: UpComingShipments },
            meta: { requiresAuth: true, roles: ["employee"] }
        },
    ]
};

let customerMenu = {
    path: "/customers",
    component: DashboardLayout,
    redirect: "/customers/buttons",
    name: "CustomerOrders",
    meta: { requiresAuth: true, roles: ["agent"] },
    children: [
        {
            path: "buttons",
            name: "Customer Orders",
            components: { default: Buttons },
            meta: { requiresAuth: true, roles: ["agent"] }
        },
        {
            path: "panels",
            name: "New order",
            components: { default: Panels },
            meta: { requiresAuth: true, roles: ["agent"] }
        }
    ]
};

let authPages = {
    path: "/",
    component: AuthLayout,
    redirect : '/mys/dashboard',
    name: "Authentication",
    meta: { requiresAuth: true },
    children: [
        {
            path: "/login",
            name: "Login",
            component: Login
        },
        {
            path: "/forgot",
            name: "Forgot",
            component: Forgot
        }
    ]
};

const routes = [
    ordersMenu,
    shippingMenu,
    customerMenu,
    authPages,
    {
        path: "/:accountId",
        component: DashboardLayout,
        meta:{ requiresAuth: true },
        children: [
            {
                path: "dashboard",
                name: "Dashboard",
                components: { default: Dashboard },
                meta: { requiresAuth: true, roles: ["agent"] }
            }
        ]
    },{
    path: '/',
    component: Dashboard
    }
];

export default routes;
